import { render, staticRenderFns } from "./buffetList.vue?vue&type=template&id=2ccc98ef&scoped=true"
import script from "./buffetList.vue?vue&type=script&lang=js"
export * from "./buffetList.vue?vue&type=script&lang=js"
import style0 from "./buffetList.vue?vue&type=style&index=0&id=2ccc98ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc98ef",
  null
  
)

export default component.exports